import { createReducer, on } from "@ngrx/store";
import { hideEditingRestrictedModal, showEditingRestrictedModal } from "../actions/shared.actions";

export const editingRestrictedKey = 'editingRestrictedModal';

export type editingRestrictedModalState = {
  active: boolean;
}

export const intitialEditingRestrictedModalState = {
  active: false
}

export const editingRestrictedModalReducer = createReducer(
  intitialEditingRestrictedModalState,
  on(showEditingRestrictedModal, (_state) => {
    return {
      active: true
    }
  }),
  on(hideEditingRestrictedModal, (_state) => {
    return {
      active: false
    }
  })
)